import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["commitButton", "confirmationMessage", "customerCheckbox", "customerCount"]

  cancelConfirmation(e) {
    e.preventDefault()

    if (this.hasCommitButtonTarget) {
      this.commitButtonTarget.classList.remove("hidden")
    }

    if (this.hasConfirmationMessageTarget) {
      this.confirmationMessageTarget.classList.add("hidden")
    }
  }

  get selectedCustomerCount() {
    if (!this.hasCustomerCheckboxTarget) {
      return 0
    }
    return this.customerCheckboxTargets.filter(checkbox => checkbox.checked).length
  }

  showConfirmation(e) {
    e.preventDefault()

    const selectedCount = this.selectedCustomerCount

    if (selectedCount === 0) {
      alert("Please select at least one customer")
      return
    }

    if (this.hasCommitButtonTarget) {
      this.commitButtonTarget.classList.add("hidden")
    }

    if (this.hasConfirmationMessageTarget) {
      this.confirmationMessageTarget.classList.remove("hidden")
    }

    if (this.hasCustomerCountTarget) {
      this.customerCountTarget.textContent = selectedCount
    }
  }
}
